/* Translate backend error to a customer friendly message to render on checkout.
 * Ideally, the error param should return a unique error code provided by API response. */
export function checkoutErrorTranslation(error) {
    switch (error) {
        case 'bacTaxRemittable':
            return 'LABEL_CHECKOUT_ERROR_TAX_REMITTABLE';
        default:
            return state;
    }
}